import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Reads ?highlight=ORDER_ID from the URL, scrolls to that element,
 * and returns the ID so components can apply a highlight ring style.
 *
 * Usage:
 *   const highlightId = useScrollHighlight();
 *   // Add to element: id={`hl-${order._id}`} data-highlight-id={order._id}
 *   // Add conditional class: highlightId === order._id ? 'ring-2 ring-orange-500' : ''
 */
export function useScrollHighlight() {
  const { search } = useLocation();
  const [highlightId, setHighlightId] = useState(null);

  useEffect(() => {
    const id = new URLSearchParams(search).get('highlight');
    if (!id) return;
    setHighlightId(id);

    // Wait for list to render, then scroll + briefly pulse
    const timer = setTimeout(() => {
      const el = document.getElementById(`hl-${id}`);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 400);

    // Remove highlight after 4 seconds
    const clearTimer = setTimeout(() => setHighlightId(null), 4000);
    return () => { clearTimeout(timer); clearTimeout(clearTimer); };
  }, [search]);

  return highlightId;
}
